// frontend/admin-portal/src/components/procurement/RequisitionStatusBadge.jsx
import React from "react";
import { Badge } from "@fiberhome/shared-ui";

const VARIANTS = {
  draft: "default",
  sent: "primary",
  quoting: "warning",
  completed: "success",
  cancelled: "danger",
  // RFQ statuses
  awaiting: "warning",
  quoted: "success",
  declined: "danger",
  // Quotation statuses
  received: "primary",
  under_review: "warning",
  accepted: "success",
  rejected: "danger",
  expired: "default",
};

export default function RequisitionStatusBadge({ status }) {
  return <Badge variant={VARIANTS[status] || "default"}>{status}</Badge>;
}
